import React from 'react';
import clsx from 'clsx';
import type { NavigationContainer } from '../../../types';
import NavigationExperiment from '../../../NavigationExperiment';
import DesktopAllCategoriesNavigation from './DesktopAllCategoriesNavigation';
import DesktopFeaturedNavigation from './DesktopFeaturedNavigation';
import DesktopSupplementaryNavigation from './DesktopSupplementaryNavigation';

type DesktopNavigationProps = {
  allCategoriesNavigation: NavigationContainer['navigation'];
  featuredNavigation: NavigationContainer['navigation'];
  supplementaryNavigation: NavigationContainer['navigation'];
  className?: string;
};

const DesktopNavigation = ({
  allCategoriesNavigation,
  featuredNavigation,
  supplementaryNavigation,
  className,
  ...rest
}: DesktopNavigationProps) => (
  <div {...rest} className={clsx('pd-hidden pd-items-center lg:pd-flex', className)}>
    <NavigationExperiment as={DesktopAllCategoriesNavigation} navigation={allCategoriesNavigation} />
    <NavigationExperiment as={DesktopFeaturedNavigation} navigation={featuredNavigation} />
    <NavigationExperiment as={DesktopSupplementaryNavigation} navigation={supplementaryNavigation} />
  </div>
);

export default DesktopNavigation;
